// removed by extract-text-webpack-plugin
module.exports = {"textBox":"_1rln"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Text/TextBox/TextBox.scss
// module id = 1LcN
// module chunks = 0